export default (url: string, width?: number): string => {
  if (width) {
    return url.replace('100-80', `${width}-80`);
  }
  return url;
};
